import { FC } from "react";
import { useSelector } from "react-redux";
import { DashboardSelectors } from "../../redux/selectors/unifiedSelectors";
import { CircularProgress } from "@mui/material";

export interface ManageWheatBarleyTitleCountProps {
  title: any;
  count: number;
  selectedCrop: { slug: string; translation: string };
  loading: boolean;
}

const ManageWheatBarleyTitleCount: FC<ManageWheatBarleyTitleCountProps> = ({
  title,
  count,
  selectedCrop,
  loading,
}) => {
  const { activityData } = useSelector(DashboardSelectors);
  const findTheColor = activityData.data.find(
    (item) =>
      item.specie.toLocaleLowerCase() ===
      selectedCrop.translation.toLocaleLowerCase(),
  )?.color;

  return (
    <div className="total-actions-dashboard">
      <div className="number-action-title">{title} </div>
      {loading ? (
        <div style={{ color: findTheColor }} className="number-action-count">
          <CircularProgress />
        </div>
      ) : (
        <div style={{ color: findTheColor }} className="number-action-count">
          {count}
        </div>
      )}
    </div>
  );
};

export default ManageWheatBarleyTitleCount;
